import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotManga from './components/HotManga';
import LatestUpdates from './components/LatestUpdates';
import FAQ from './components/FAQ';

export default function Home() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '酷漫屋的漫画都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，酷漫屋上所有漫画资源均可免费在线阅读，无需付费，无需注册。我们致力于为漫画爱好者提供最便捷的免费漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '酷漫屋支持哪些类型的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '酷漫屋涵盖了日漫、韩漫、国漫等多种类型的免费漫画资源，包括热血、恋爱、奇幻、冒险、搞笑、战斗、悬疑、玄幻等丰富题材。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在酷漫屋上搜索想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以使用首页顶部的搜索框直接输入漫画名称搜索，也可以通过分类导航浏览日漫、韩漫、国漫等不同分类的漫画列表。',
        },
      },
      {
        '@type': 'Question',
        name: '阅读时是否支持下拉式滚动？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，酷漫屋支持下拉式滚动阅读模式，您可以像浏览网页一样流畅地阅读漫画，无需频繁翻页。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们会在漫画官方更新的第一时间同步更新，确保您能及时追更最新章节。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '酷漫屋 - 免费漫画全集在线阅读',
            description: '酷漫屋提供海量免费漫画资源，支持免费看漫画、免费在线漫画，下拉式滚动阅读，日漫韩漫国漫免费看，漫画免费追更。',
            url: 'https://kumanwu.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '酷漫屋',
              url: 'https://kumanwu.com',
            },
          }),
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotManga />
        <LatestUpdates />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}